// Telegram WebApp SDK (скрипт у index.html). Поза Telegram (браузер у розробці) — порожня заглушка.
type TgWebApp = {
  initData: string;
  initDataUnsafe?: { start_param?: string; user?: { language_code?: string } };
  ready: () => void;
  expand: () => void;
  close: () => void;
  HapticFeedback?: { notificationOccurred: (t: 'success' | 'error' | 'warning') => void };
};

declare global {
  interface Window {
    Telegram?: { WebApp?: TgWebApp };
  }
}

export function tg(): TgWebApp | null {
  return window.Telegram?.WebApp ?? null;
}

/** initData з Telegram; у розробці — ?initData=… (підписані бекендом тестові дані, див. README). */
export function initData(): string {
  const fromTg = tg()?.initData;
  if (fromTg) return fromTg;
  const q = new URLSearchParams(window.location.search).get('initData');
  return q ?? (import.meta.env.VITE_DEV_INIT_DATA as string | undefined) ?? '';
}

export function haptic(kind: 'success' | 'error' | 'warning'): void {
  tg()?.HapticFeedback?.notificationOccurred(kind);
}

export function closeApp(): void {
  const t = tg();
  if (t) t.close();
  else window.history.back();
}
